const PREFIX = 'applyt:app-question-draft:v1:';

function storage(): Storage | null {
  try { return typeof window === 'undefined' ? null : window.sessionStorage; } catch { return null; }
}

/** Event IDs are immutable. A draft is restored only by the currently rendered
 * actionable event with that same ID; it is never an instruction to submit. */
export function readAppQuestionDraft<T>(eventId: string, parse: (value: unknown) => T | null): T | null {
  try {
    const raw = storage()?.getItem(`${PREFIX}${eventId}`);
    return raw ? parse(JSON.parse(raw)) : null;
  } catch { return null; }
}

export function restoreActionableQuestionDraft<T>(
  eventId: string,
  actionable: boolean,
  parse: (value: unknown) => T | null,
): T | null {
  return actionable ? readAppQuestionDraft(eventId, parse) : null;
}

export function writeAppQuestionDraft(eventId: string, value: unknown): void {
  try { storage()?.setItem(`${PREFIX}${eventId}`, JSON.stringify(value)); } catch { /* noop */ }
}

export function clearAppQuestionDraft(eventId: string): void {
  try { storage()?.removeItem(`${PREFIX}${eventId}`); } catch { /* noop */ }
}
